import { render, staticRenderFns } from "./EntityCalendarWidgets.vue?vue&type=template&id=4e5e832c&scoped=true"
import script from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
export * from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
import style0 from "./EntityCalendarWidgets.vue?vue&type=style&index=0&id=4e5e832c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e832c",
  null
  
)

export default component.exports